import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "react-responsive-combo-box"
    }}>{`React Responsive Combo Box`}</h1>
    <p>{`A React library which provides you the combo-box component with lots of awesome features and can be easy-customizable.`}</p>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ol>
      <li parentName="ol"><strong parentName="li">{`Fully Flexible:`}</strong>{` The options container are completely flexible and absolute positioned, You can use wherever you want.It won't affect other components.`}</li>
      <li parentName="ol"><strong parentName="li">{`User Friendly:`}</strong>{` The component is make very user-friendly. The users will be able to use this component very easy and comfortably.`}</li>
      <li parentName="ol"><strong parentName="li">{`Fully Managed State:`}</strong>{` Unlike most other libraries, state of combo box is managed by the library so that you don't have to.`}</li>
      <li parentName="ol"><strong parentName="li">{`Responsive:`}</strong>{` The component is fully responsive. The options container will be positioned top or bottom based on the space available in the window or document.`}</li>
      <li parentName="ol"><strong parentName="li">{`Autocomplete:`}</strong>{` The user can be able to search in the input and the options are filtered based on the text in the input.`}</li>
    </ol>
    <h2 {...{
      "id": "motivation"
    }}>{`Motivation`}</h2>
    <p>{`There are a lot of libraries out there which set out to do the same thing, some accomplished it some don't. But, I always found one or another thing missing in them. Hence, I built this library to fulfill my needs and possibly yours.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      